import config from '../../config/customer.api'
import {
  Request
} from '../shared/base.requests'
export const garageModule = {
  namespaced: true,
  state: {
    purchased: [],
    favorites: []
  },
  mutations: {
    setPurchased (state, data) {
      state.purchased = data
    },
    setFavorites (state, data) {
      state.favorites = data
    },
    deleteFavorite (state, contactVehicleId) {
      let a = state.favorites.filter(x => x.contactVehicleId !== contactVehicleId)
      state.favorites = a
    }
  },
  actions: {
    loadPurchased (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.getPurchased)
            .then(response => {
              context.commit('setPurchased', response.model)
              resolve()
            })
            .catch(error => {
              console.error('load purchased vehicles failed', error)
              reject()
            })
      })
    },
    loadFavorites (context) {
      return new Promise((resolve, reject) => {
        Request.get(config.getFavorites)
            .then(response => {
              context.commit('setFavorites', response.model)
              resolve()
            })
            .catch(error => {
              console.error('load purchased vehicles failed', error)
              reject()
            })
      })
    },
    toggleFavorite ({commit}, data) {
      console.log('data:', data)
      commit('deleteFavorite', data.contactVehicleId)
      return new Promise((resolve, reject) => {
        Request.post(config.toggleFavorite, data).then((res) => {
          // if (res.success) {
          //   commit('deleteFavorite', data.contactVehicleId)
          // }
          resolve()
        }).catch(err => {
          console.error('Toggle vehicle favorite error:', err)
          reject()
        })
      })
    }
  },
  getters: {
    purchased: state => {
      return [...state.purchased]
    },
    favorites: state => {
      return [...state.favorites]
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/store/garage.js